var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"items":_vm.filteredLeads,"loading-text":"A carregar...","headers":_vm.headers,"loading":_vm.loaderDataTable,"items-per-page":_vm.itemsPerPage,"hide-default-footer":_vm.hideDefaultFooter},scopedSlots:_vm._u([{key:"item.editar",fn:function(ref){
var item = ref.item;
return [_c('LeadInsertData',{attrs:{"lead":item},on:{"update-made":_vm.collect_leads}})]}},{key:"item.detalhes",fn:function(ref){
var item = ref.item;
return [_c('LeadDetail',{attrs:{"lead":item}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }